<template>
  <div>
    <div class="relative bg-[#FDF9EE] min-h-screen">
      <!-- <div class="absolute top-0 left-0 w-full h-full" style="z-index: -9" :class="{ hidden: $route.path === '/terms-and-conditions' }">
        <img src="../../assets/images/body-Bg.png" alt="Body Bg" class="w-full h-full object-cover">
      </div> -->
      <FLoader />
      <div v-if="$route.path !== '/thankyou'" :class="[
        ($route.path === '/terms-and-conditions' || $route.path === '/privacy-policy')
          ? 'hidden'
          : ''
      ]" class="absolute top-0 right-0 w-[250px] laptop:w-[350px] desktop:w-[450px] largeDesktop:w-[550px]">
        <img src="../../assets/images/circle-bg.png" alt="Body Bg" class="w-full object-cover">
      </div>
      <!-- this icon only for dashboard -->
      <div v-if="$route.path === '/dashboard'" class="absolute bottom-0 right-0 w-[270px] hidden laptop:block">
        <img src="../../assets/images/circle-dashboard.png" alt="Body icon" class="w-full object-cover">
      </div>
      <!-- this img just for dashboard page  -->
      <div v-if="$route.path === '/dashboard'"
        class="absolute bottom-[45px] -left-[60px] laptop:w-[400px] largeDesktop:w-[670px]">
        <img src="../../assets/images/men-img.svg" alt="Body Bg" class="w-full object-cover mobile:hidden laptop:block">
        <img src="../../assets/images/men-img-mobile.png" alt="Body Bg"
          class="w-full object-cover mobile:block laptop:hidden">
      </div>
      <!-- this img just for thank you page  -->
      <div v-if="$route.path === '/thankyou'"
        class="hidden absolute bottom-[15px] mobile:translate-x-1/2 laptop:translate-x-[unset]  mobile:right-[56%] laptop:right-[unset] mobile:left-[unset] laptop:-left-[60px] w-[320px] laptop:w-[400px] largeDesktop:w-[670px]">
        <img src="../../assets/images/men-img.svg" alt="Body Bg" class="w-full object-cover mobile:hidden laptop:block">
        <img src="../../assets/images/men-img-mobile.png" alt="Body Bg"
          class="w-full object-cover mobile:block laptop:hidden">
      </div>
      <div v-else :class="[
        ($route.path === '/terms-and-conditions' || $route.path === '/privacy-policy')
          ? 'hidden'
          : ''
      ]" class="absolute mobile:bottom-0 mobile:z-[99] laptop:z-auto laptop:bottom-[45px] left-0 mobile:w-[90px] laptop:w-[300px] largeDesktop:w-[400px]">
        <img src="../../assets/images/men-img.svg" alt="Body Bg" class="w-full object-cover mobile:hidden laptop:block">
        <img src="../../assets/images/men-img-mobile.png" alt="Body Bg"
          class="w-full object-cover mobile:block laptop:hidden">
      </div>
      <div
        
        :class="[isFromMobile == 1 ? '!pt-[0px]' : '',
        ($route.path === '/terms-and-conditions' || $route.path === '/privacy-policy')
          ? '!pt-[20px] bg-[#FDF9EE]'
          : ''
      ]">
        <router-view></router-view>
      </div>
    </div>
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>

<script>
export default {
  name: "Layout",

  components: {

  },

  data() {
    return {

    };
  },

  computed: {
    isFromMobile() {
      return this.$route.query.is_from_mobile ?? 0;
    },

  },
  mounted() { },

  methods: {

  }
};
</script>
